import React from 'react';
import { Switch } from '@mui/material';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';

interface SwitchMobileProps {
    isPro: boolean;
    setIsPro: (value: boolean | ((prev: boolean) => boolean)) => void;
    positionTop: number;
}

const CustomSwitch = styled(Switch)(() => ({
    width: 90,
    height: 40,
    borderRadius: 25,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 10,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(40px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: 'transparent',
            },
            '& .MuiSwitch-thumb': {
                backgroundColor: '#FF4D00',
            },
        },
        '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: 'transparent',
        },
    },
    '& .MuiSwitch-thumb': {
        width: 30,
        height: 20,
        borderRadius: 30,
        backgroundColor: '#FF4D00',
    },
    '& .MuiSwitch-track': {
        backgroundColor: 'transparent',
    },
}));

const SwitchMobile: React.FC<SwitchMobileProps> = ({ isPro, setIsPro, positionTop }) => {
    const { t } = useTranslation();

    return (
        <div
            style={{
                position: 'absolute',
                top: positionTop,
                left: 30,
                width: 273,
                height: 47,
                background: '#FFFFFF',
                boxShadow: '0px 1px 6px #0F4D0029',
                borderRadius: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-evenly',
                padding: '0 15px',
            }}
        >
            <div
                style={{
                    flex: 1,
                    textAlign: 'left',
                    fontSize: 12,
                    color: isPro ? '#737373' : '#FF4D00',
                    fontWeight: isPro ? 300 : 700,
                    cursor: 'pointer'
                }}
                onClick={() => setIsPro(false)}
            >
                {t('page1:switch_particulars')}
            </div>
            <div
                style={{
                    width: 81,
                    height: 27,
                    borderRadius: 50,
                    border: '2px solid #707070',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                }}
                onClick={() => setIsPro((prev) => !prev)}
            >
                <CustomSwitch checked={isPro}/>
            </div>
            <div
                style={{
                    textAlign: 'right',
                    flex: 1,
                    fontSize: 12,
                    color: isPro ? '#FF4D00' : '#737373',
                    fontWeight: isPro ? 700 : 300,
                    cursor: 'pointer',
                }}
                onClick={() => setIsPro(true)}
            >
                {t('page1:switch_pros')}
            </div>
        </div>
    );
};

export default SwitchMobile;
